import NavigationBar from "../components/NavBar";
import {Outlet} from "react-router-dom";
import '../styles/Root.scss';
import React from "react";
import {AlfySidebar} from "../components/sidebar/AlfySidebar";
import {Box} from "@mui/material";
import {ToastContainer} from "react-toastify";
import ScrollToTop from "./ScrollToTop";
import {usePageTracking} from "../hooks/googleAnalyticsHooks";

const BaseLayout: React.FC = () => {
    usePageTracking()

    return (
        <div id="base-wrapper">
            <AlfySidebar/>
            <NavigationBar />
            <main>
                <Box height={'56px'} />
                <ScrollToTop>
                    <Outlet/>
                </ScrollToTop>
                <ToastContainer />
            </main>
        </div>
    );
}

export default BaseLayout;